import { companyProfileText } from 'data/companyProfileText';
import * as Toast from 'utils/toast';

const buildValue = (key, companyProfile) => {
    if (key === 'address') return [companyProfile.address, companyProfile.postCode].filter(Boolean).join(', ');
    return companyProfile[key];
};

const handleCopy = (value) => {
    if (!value || value === '-') return;

    navigator.clipboard
        .writeText(value)
        .then(() => Toast.showSuccessMessage('Copied to clipboard'));
};

const CompanyBusinessInfo = ({ className, companyProfile }) => {
    const fields = companyProfileText.map((x) => ({
        label: x.label,
        value: buildValue(x.key, companyProfile) || '-'
    }));

    return (
        <div className={`d-flex flex-column ${className ? className : ''}`}>
            {fields.map((x, index) => {
                const isFirstItem = index === 0;

                return (
                    <div
                        key={x.label}
                        className={`d-flex fs-5 ${isFirstItem ? '' : 'mt-1'}`}
                        onClick={() => handleCopy(x.value)}
                    >
                        <span className="text-nowrap me-3">{x.label}</span>
                        <span className="flex-grow-1 text-end fw-bold" style={{ userSelect: 'text' }}>
                            {x.value}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default CompanyBusinessInfo;
